import { Icon, IconProps } from "./Icon";

export function IconStroller(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M8.49 1h2.92L9.46 7h1l2.28-7H8.49A8.46 8.46 0 0 0 .17 7h1a7.45 7.45 0 0 1 7.32-6Zm12.98 4-2.26 3H0v.54a8.54 8.54 0 0 0 3.41 6.81l5.87 4.17-2.5 1.94A2.5 2.5 0 1 0 4.32 24a2.38 2.38 0 0 0 1.41-.46l-.05.05.09-.07.09-.07 4.3-3.31 4 2.95a2.68 2.68 0 0 0 1.92.91 2.5 2.5 0 1 0-2.5-2.58L11 19.59l5.52-4.18A8.69 8.69 0 0 0 20 8.63L22 6h2V5ZM4.32 23a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm11.76-3a1.5 1.5 0 0 1 0 3 1.49 1.49 0 0 1-1.19-.6h-.05a1.45 1.45 0 0 1-.26-.85 1.5 1.5 0 0 1 1.5-1.55Zm-5.94-1.11-2.79-2a7.45 7.45 0 0 0 1.06.11h3.21a7.74 7.74 0 0 0 1.19-.1ZM11.62 16H8.41a7.47 7.47 0 0 1-7.36-7H19a7.46 7.46 0 0 1-7.38 7Z" />
    </Icon>
  );
}
